import { render, staticRenderFns } from "./book.vue?vue&type=template&id=01bb5f63&"
import script from "./book.vue?vue&type=script&lang=js&"
export * from "./book.vue?vue&type=script&lang=js&"
import style0 from "./book.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sacha\\dotnet\\ChoupsBooking\\src\\Satrabel.ChoupsBooking\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('01bb5f63', component.options)
    } else {
      api.reload('01bb5f63', component.options)
    }
    module.hot.accept("./book.vue?vue&type=template&id=01bb5f63&", function () {
      api.rerender('01bb5f63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/calendar/book.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./ClientApp/calendar/book.vue
// module id = 332
// module chunks = 2